import {
  Container,
  SkipButton,
  Title,
  Content,
  LogoImage,
  LogoWrapper,
  LinksContainer,
  ContinueButton,
} from "./styles.js";
import logo from "../../assets/LogoPos2.png";
import { useHistory, useLocation } from "react-router-dom";
import api from "../../services/client/api";
import React, { useState, useEffect } from "react";
import cookie from "../../services/cookie/index";
import { Table, Input } from "reactstrap";
function Terms() {
  const location = useLocation();
  const history = useHistory();
  const [showScrollButton, setShowScrollButton] = useState(true);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolledToBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 70;
      setShowScrollButton(!scrolledToBottom);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const {
    username,
    firstName,
    name,
    role,
    code,
    requirePermission,
    codTitulo,
    verifiedDoctor,
    token,
    crm,
    cpf,
  } = location.state || {};

  useEffect(() => {
    if (!verifiedDoctor) {
      history.replace("/login");
    }
  }, [verifiedDoctor, history]);

  const handleAccepted = async () => {
    api().user().acceptTerms({ username, name, crm }, token);
    await cookie().set("name", name, 5 / 24);
    await cookie().set("CodTitulo", codTitulo, 5 / 24);
    await cookie().set("username", username, 5 / 24);
    await cookie().set("code", code, 5 / 24);
    await cookie().set("role", role, 5 / 24);
    await cookie().set("requirePermission", requirePermission, 5 / 24);
    await cookie().set("token", token, 5 / 24);
    await cookie().set("DocList", "false", 5 / 24);

    history.replace({ pathname: "/" });
  };

  return (
    <>
      {showScrollButton && (
        <SkipButton
          onClick={() => {
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: "smooth",
            });
          }}
        >
          Ir para o fim da página ↓
        </SkipButton>
      )}
      <LogoWrapper>
        <LogoImage
          onClick={() => history.replace({ pathname: "/login" })}
          src={logo}
          alt="Logo CEDAP"
        />
      </LogoWrapper>
      <Container>
        <Title>
          TERMO DE RESPONSABILIDADE, CONFIDENCIALIDADE E AUTORIZAÇÃO DE ACESSO
          AO PORTAL DE EXAMES
        </Title>

        <Content>
          <p>
            Pelo presente instrumento, o(a) médico(a) abaixo identificado(a),
            declara estar ciente e concordar com as condições abaixo para
            utilização do Portal de Exames disponibilizado pelo Laboratório.
          </p>

          <p>
            <strong>Nome:</strong>
            <u> {name || "____________________________________________"} </u>
            <br />
            <strong>CRM:</strong>
            <u> {crm || "____________________________________________"} </u>
          </p>

          <h2>1. DO OBJETO</h2>

          <p>
            O presente Termo tem por finalidade regulamentar o acesso ao Portal
            de Exames destinado a médicos que, em razão de sua atuação
            profissional, necessitam consultar exames anatomopatológicos de
            pacientes envolvidos em procedimentos realizados por si, ainda que
            tais exames tenham sido formalmente solicitados por outro médico.
          </p>

          <p>
            Esse acesso constitui modalidade específica e excepcional, distinta
            do acesso concedido ao médico solicitante dos exames.
          </p>

          <h2>2. DA FINALIDADE DO ACESSO</h2>

          <p>
            O acesso concedido destina-se exclusivamente ao acompanhamento
            assistencial dos pacientes relacionados à atuação profissional do
            médico autorizado, sendo vedada qualquer utilização diversa.
          </p>

          <p>
            O médico declara que utilizará as informações apenas quando houver
            vínculo assistencial legítimo com o paciente e necessidade
            relacionada à continuidade do atendimento.
          </p>

          <h2>3. DA CONFIDENCIALIDADE</h2>

          <p>
            O médico reconhece que todas as informações disponibilizadas no
            Portal possuem caráter confidencial e incluem dados pessoais e dados
            pessoais sensíveis, protegidos pela Lei nº 13.709/2018 (LGPD), bem
            como pelo Código de Ética Médica e demais normas aplicáveis.
          </p>

          <p>Compromete-se a:</p>

          <ul>
            <li>
              manter absoluto sigilo sobre todas as informações acessadas;
            </li>
            <li>
              não compartilhar login, senha ou qualquer forma de acesso com
              terceiros;
            </li>
            <li>
              não permitir que pessoas não autorizadas utilizem sua conta;
            </li>
            <li>
              adotar todas as medidas necessárias para preservar a
              confidencialidade dos dados;
            </li>
            <li>
              utilizar as informações exclusivamente para fins profissionais e
              assistenciais.
            </li>
          </ul>

          <h2>4. DAS RESPONSABILIDADES DO MÉDICO</h2>

          <p>O médico declara estar ciente de que:</p>

          <ol type="I">
            <li>
              é o único responsável por todas as ações realizadas mediante seu
              login e senha;
            </li>
            <li>
              deverá comunicar imediatamente ao Laboratório qualquer suspeita de
              uso indevido de suas credenciais;
            </li>
            <li>
              não poderá copiar, reproduzir, divulgar, fotografar, imprimir ou
              compartilhar exames sem respaldo legal, ético ou autorização
              aplicável;
            </li>
            <li>
              responderá civil, administrativa, ética e criminalmente por
              eventual utilização indevida das informações acessadas.
            </li>
          </ol>

          <h2>5. DA LGPD</h2>

          <p>
            O médico declara ciência de que os dados disponibilizados no Portal
            constituem dados pessoais e dados pessoais sensíveis, tratados para
            fins de assistência à saúde, observando as hipóteses legais
            previstas na Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
          </p>

          <p>
            O acesso às informações deverá observar os princípios da finalidade,
            necessidade, adequação, segurança e confidencialidade previstos na
            legislação vigente.
          </p>

          <h2>6. DO MONITORAMENTO E REGISTRO DAS ATIVIDADES</h2>

          <p>
            O médico declara estar ciente de que o Portal mantém mecanismos de
            auditoria e segurança destinados à proteção das informações.
          </p>

          <p>
            Todas as operações realizadas poderão ser registradas, incluindo:
          </p>

          <ul>
            <li>autenticação (login e logout);</li>
            <li>data e horário de acesso;</li>
            <li>endereço IP e informações técnicas da conexão;</li>
            <li>exames consultados;</li>
            <li>pacientes visualizados;</li>
            <li>downloads, impressões e demais operações realizadas;</li>
            <li>demais ações executadas no sistema.</li>
          </ul>

          <p>
            Esses registros poderão ser utilizados para auditorias internas,
            investigação de incidentes de segurança, atendimento de obrigações
            legais e regulatórias, bem como para eventual apuração de uso
            inadequado do sistema.
          </p>

          <h2>7. DA REVOGAÇÃO DO ACESSO</h2>

          <p>
            O Laboratório poderá, a qualquer momento e independentemente de
            aviso prévio, suspender ou cancelar o acesso do médico quando
            verificar:
          </p>

          <ul>
            <li>utilização em desacordo com este Termo;</li>
            <li>suspeita de acesso indevido;</li>
            <li>compartilhamento de credenciais;</li>
            <li>violação da confidencialidade das informações;</li>
            <li>determinação legal ou administrativa;</li>
            <li>
              qualquer situação que represente risco à segurança das
              informações.
            </li>
          </ul>

          <h2>8. DAS DISPOSIÇÕES GERAIS</h2>

          <p>O médico declara que:</p>

          <ul>
            <li>leu integralmente este Termo;</li>
            <li>compreendeu suas obrigações;</li>
            <li>concorda com todas as condições estabelecidas;</li>
            <li>
              compromete-se a observar a legislação vigente, especialmente a Lei
              Geral de Proteção de Dados (Lei nº 13.709/2018), o Código de Ética
              Médica e as normas aplicáveis ao sigilo das informações em saúde.
            </li>
          </ul>

          <p>
            O acesso ao Portal somente será disponibilizado após a manifestação
            expressa de concordância com este Termo.
          </p>

          <hr />

          <p>
            <strong>Declaração de Concordância</strong>
          </p>

          <p>
            Declaro que li e concordo integralmente com este Termo de
            Responsabilidade, Confidencialidade e Uso do Portal de Exames. Estou
            ciente de que meu acesso é pessoal e intransferível, que todas as
            minhas ações no sistema serão registradas para fins de auditoria e
            segurança, e que responderei pelo uso indevido das informações
            disponibilizadas, nos termos da legislação aplicável, incluindo a
            Lei Geral de Proteção de Dados (Lei nº 13.709/2018), o Código de
            Ética Médica e demais normas pertinentes.
          </p>

          <p>
            <em>Última atualização: 16 de julho de 2026.</em>
          </p>
        </Content>
        <div style={{ marginTop: "15px", fontWeight: "600" }}>
          <Input
            type="checkbox"
            checked={accepted}
            onChange={() => setAccepted(!accepted)}
          />
          <label>Li e concordo integralmente com este termo.</label>
        </div>
      </Container>

      <LinksContainer>
        <ContinueButton disabled={!accepted} onClick={handleAccepted}>
          Confirmar ✓
        </ContinueButton>
      </LinksContainer>
    </>
  );
}

export default Terms;
